




<template>

<div style= "overflow: scroll; max-height: 568px;" >

     <v-expansion-panels style="text-align: right;">
                <v-expansion-panel>
                  <v-expansion-panel-header style="text-align: right;">
        
                    <span >  <i class="material-icons">escalator_warning</i>חברה וקהילה
                  
                      <v-badge style="margin-right: 10px; margin-bottom: 5px"
                        color="green"
                        content="1"
                        v-if="$store.state.layer_index > -1"
                      >
                      </v-badge>
                    
                    </span>

                    </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-list>
                              <v-list-item-group
                                active-class="border"
                                color="indigo"
                              >
                                <v-list-item
                                  v-for="(item, i) in layers"
                                  :key="i"
                                  @click="switchLayer(i)"
                                >
                                  <v-list-item-content>
                                    <v-list-item-title style="font-size: 12px" v-text="item.text"></v-list-item-title>
                                  </v-list-item-content>
                                  <v-icon @click="layerInfo(item)" v-show="i == $store.state.layer_index" color="indigo" small>info</v-icon>
                                </v-list-item>
                              </v-list-item-group>
                            </v-list>
                          </v-expansion-panel-content>
                </v-expansion-panel>
                </v-expansion-panels>

              <v-expansion-panels style="text-align: right;">
                <v-expansion-panel>
                  <v-expansion-panel-header style="text-align: right;">
        
                    <span >  <i class="material-icons">domain</i>חלוקה מנהלית
                    
                    
                     <v-badge style="margin-right: 10px; margin-bottom: 5px"
                        color="green"
                        content="1"
                        v-if="$store.state.minhali_index > -1"
                      >
                      </v-badge>
                    
                    </span>

                    </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-list>
                              <v-list-item-group
                                active-class="border"
                                color="indigo">
                                <v-list-item
                                  v-for="(item, i) in minhali"
                                  :key="i" @click="switchMinhaliLayer(i)">
                                  <v-list-item-content>
                                       <v-list-item-title style="font-size: 12px" v-text="item.text">
                                       </v-list-item-title>
                                  </v-list-item-content>
                                   <v-icon @click="layerInfo(item)" v-show="i == $store.state.minhali_index" color="indigo" small>info</v-icon>
                                </v-list-item>
                              </v-list-item-group>
                            </v-list>
                          </v-expansion-panel-content>
                </v-expansion-panel>
                </v-expansion-panels>

    
                  <v-expansion-panels style="text-align: right;" v-for="(group, i) in $store.state.groups" :key="i">
                      <v-expansion-panel>
                        <v-expansion-panel-header style="text-align: right;">
              
                          <span>
                            <v-icon color="blue darken-2">{{`mdi-${group.group_icon}`}}</v-icon> {{group.group_name}}
                          <v-badge style="margin-right: 10px; margin-bottom: 5px"
                              color="green"
                              :content="groupSelected(group).length"
                              v-if="groupSelected(group).length > 0"
                            >
                            </v-badge>
                            </span>
                          </v-expansion-panel-header>

                          <v-expansion-panel-content >

                            <v-expansion-panels v-for="(sub_group, i) in group.sub_groups" :key="i" right style="text-align: right;">
                            <v-expansion-panel style="text-align: right;">
                              <v-expansion-panel-header style="text-align: right; font-size: 12px;">
                                <span ><v-icon>{{`mdi-${sub_group.sub_group_icon}`}}</v-icon> {{sub_group.sub_group_name}}</span>
                                  </v-expansion-panel-header>
                                  <v-expansion-panel-content v-for="(item, i) in sub_group.sub_group_layers"  :key="i" >
                                     <v-row>
                                        <v-checkbox color="indigo" @click="checkSelectedLayers()" :value="item.layer_name" v-model="sub_group.selected" class="my-checkbox"  hide-details> 
                                            <template v-slot:label>
                                              <span style="font-size: 12px">{{item.text}}</span>
                                            </template>
                                        </v-checkbox>
                                          <v-icon @click="layerInfo(item)"  color="indigo" small>info</v-icon>
                                     </v-row>
                                  </v-expansion-panel-content>
                            </v-expansion-panel>
                            </v-expansion-panels>
                          </v-expansion-panel-content>
                      </v-expansion-panel>
                      </v-expansion-panels>


   

                      </div>


                      


</template>



    <script src="https://code.jquery.com/jquery-1.12.1.min.js"></script>
    <script src="https://www.govmap.gov.il/govmap/api/govmap.api.js"></script>


<script>


    function PointToPolygon(x, y, r)
		{			
			var x1 = x - r;
			var y1 = y;
			var x2 = x - (((r / 2)) / (2)) - ((r / 2));
			var y2 = y + (((r / 2)) / (2)) + ((r / 2));
			var x3 = x;
			var y3 = y + r;
			var x4 = x + (((r / 2)) / (2)) + ((r / 2));
			var y4 = y + (((r / 2)) / (2)) + ((r / 2));
			var x5 = x + r;
			var y5 = y;
			var x6 = x + (((r / 2)) / (2)) + ((r / 2));
			var y6 = y - (((r / 2)) / (2)) - ((r / 2));
			var x7 = x;
			var y7 = y - r;
			var x8 = x - (((r / 2)) / (2)) - ((r / 2));
			var y8 = y - (((r / 2)) / (2)) - ((r / 2));
			var wkt = "POLYGON(("+x1+" "+y1+", "+x2+" "+y2+", "+x3+" "+y3+", "+x4+" "+y4+", "+x5+" "+y5+", "+x6+" "+y6+", "+x7+" "+y7+", "+x8+" "+y8+", "+x1+" "+y1+"))";
			return wkt;
		}


var thisVue;


  export default {
    name: 'ExpansionPanels',

    data: () => ({

        isActive: false,
        isMinhaliActive: false,

        selected: [],
        selected_rails: [],
        selectedItem: 1,
        layer: null,
        transport_selected: [],
        selected_city: [],
        env_selected:[],


         items: [],
      model: 1,

     
    }),

     methods:{


      groupSelected(group){
         var all_selected = [];
         for (var i = 0 ; i < group.sub_groups.length; i++){
          var sg = group.sub_groups[i];
          for (var ii = 0; ii < sg.selected.length; ii++){
            all_selected.push(sg.selected[ii]);
          }

         }
         console.log(all_selected);
         return all_selected;

       },


    layerInfo(item){

      this.$store.state.LayerNameInfo = item.text;
      this.$store.state.showLayerInfo = true;   

    },
    clickLegend(layer,item){
      //console.log(item.text);
      //console.log(layer.layer_name);
      //console.log(layer.symbol_field);
      var params = {
                      'layerName': layer.layer_name,
                      'fieldName': layer.symbol_field,
                      'fieldValues': [item.text],
                      'highlight': true,
                      'showBubble':false,
                      'outLineColor':[127, 246, 223, 1],
                      'outlineWidth': 1, 
                      'fillColor': [255, 255, 255, 0.5]
                  };
      //govmap.searchInLayer(params);

      govmap.searchInLayer({ 'layerName': layer.layer_name, 'fieldName': layer.symbol_field,
                  'fieldValues': [item.text],
                  'highlight': true,
                  'showBubble':false,
                  'outLineColor':[127, 246, 223, 1],
                  'outlineWidth': 1, 
                  'fillColor': [255, 255, 255, 0.5]});
      

    },
    geocode () {
			
			////console.log(this.geocode_text);


			govmap.geocode({keyword: this.geocode_text},govmap.geocodeType.FullResult)
					.then(function(response){
						////console.log("then:");
						////console.log(response);
						govmap.zoomToXY({ x: response.data[0].X, y: response.data[0].Y, level: 10, marker: true });
			});

		},
    Measure()
    {
      govmap.showMeasure();  
    },
    exportMap(){
			govmap.showExportMap();
		},
		print(){
			govmap.showPrint();
		},

    

    createRenderer(layer)
    {
        //var appVue = this;
        var layerForRenderer = [];
        var lname = layer.layer_name;
        //this.layer = layer.text;
        layerForRenderer.push(lname);

        var items = [];

        var layers = { LayerNames: layerForRenderer };

        govmap.getLayerRenderer(layers)
            .then(function (e) {
                //console.log(e);
                for (var object in e.data.Renderers) {
                    for (var obj in e.data.Renderers[object].RendererList) {
                        if (obj == "") {

                          ////console.log(e.data.Renderers[object].LayerCaption)
                          items.push({text: "", icon: e.data.Renderers[object].RendererList[obj] });
                        }
                        else
                        {
                          ////console.log(obj)
                          //td.appendChild(document.createTextNode(obj));
                          items.push({text:obj, icon: e.data.Renderers[object].RendererList[obj] });
                          //document.getElementById('rndrHeader').innerHTML = lyrRendererDesc[lname];
                        }
      
                    }

                    if (layer.layer_name== "HEAT"){
                        items.push(items.shift())
                      //items = items.sort((a, b) => (a.text > b.text) ? 1 : -1)
                    }
                    if (layer.layer_name== "earthquakes"){
                       items.unshift(items.pop())
                    }

                    //////console.log(items);
                    
                    

                }
                

            });
 
            return items;
            
            

    },

    clearSelection(){
      ////////console.log(this.$store.state.layer_index);
      govmap.clearSelection();
      //this.$store.state.layer_index = -1;
      this.$store.state.selected_data_reg= [];
      this.$store.state.selected_data_arab= [];
      //this.$store.state.selectedLayer= null;
      this.$store.state.img = "";
      this.closeArrow = false;

            this.$store.state.img = "https://raw.githubusercontent.com/yovavsanders/govmap/master/images/"+this.selectedLayer.layer_name+".jpg";
      ////////console.log(this.$store.state.img)
      ////////console.log(this.$store.state.img);
      govmap.setVisibleLayers([this.selectedLayer.layer_name], this.unselectedLayers)
      if(this.isMobile()){
        this.drawer = false;
      }

      //this.scrollUp();


    },

    scrollUp(){
       $('html, body').animate({ scrollTop: 0 }, 'fast');
       this.showArrow=false;
    },

     isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },


      switchMinhaliLayer(i){
        thisVue = this;
      if (i == this.$store.state.minhali_index)
      {
        if (!this.isMinhaliActive) {
          this.isMinhaliActive = true;
          this.$store.state.minhali_index = i;
          this.$store.state.selectedMinhaliLayer = this.$store.state.minhali[this.$store.state.minhali_index];
          this.$store.state.img = "https://raw.githubusercontent.com/yovavsanders/govmap/master/images/"+this.$store.state.selectedMinhaliLayer.layer_name+".jpg";
          this.$store.state.turnOnLayers.push(this.$store.state.selectedMinhaliLayer.layer_name)
          govmap.setVisibleLayers(this.$store.state.turnOnLayers, this.$store.state.turnOffLayers)
          govmap.unbindEvent(govmap.events.CLICK);
          this.$store.state.clickMapMessage = true;
        } else {
          this.isMinhaliActive = false;
          this.$store.state.minhali_index = -1;
          this.$store.state.selectedMinhaliLayer = null;
          govmap.setVisibleLayers([], this.allLayers)
        }
      }
      else{
          this.isMinhaliActive = false;
          this.$store.state.minhali_index = i;
          this.$store.state.selectedMinhaliLayer = this.$store.state.minhali[this.$store.state.minhali_index];
          this.$store.state.img = "https://raw.githubusercontent.com/yovavsanders/govmap/master/images/"+this.$store.state.selectedMinhaliLayer.layer_name+".jpg";
          ////////console.log(this.$store.state.img)
          ////////console.log(this.$store.state.img);
          govmap.setVisibleLayers([this.$store.state.selectedMinhaliLayer.layer_name], this.unselectedMinhaliLayers)

                  //   console.log("govmap.onEvent(govmap.events.CLICK)");
                  //          govmap.onEvent(govmap.events.CLICK).progress(function(e){
                  //   //////console.log(thisVue.selectedLayer.fields)
                  //   thisVue.closeArrow = true;
                  //   var wkt = PointToPolygon(e.mapPoint.x, e.mapPoint.y, 1)
                  //   var layersToQuery = [thisVue.layers[0], thisVue.layers[1], thisVue.layers[2]]
                  //   for (var i = 0; i < layersToQuery.length; i++)
                  //   {
                  //     thisVue.getData(wkt, layersToQuery[i].layer_name, layersToQuery[i].fields);
                  //   }
                  // }); 


          this.$store.state.clickMapMessage = true;

          this.isMinhaliActive = true;
      }
      if(this.isMobile()){
        this.drawer = false;
      }
      else{
        this.getSelectedLayers();
      }
      this.getSelectedLayers();
    },
  
    switchLayer(i){
      thisVue = this;
      if (i == this.$store.state.layer_index)
      {
        if (!this.isActive) {
          this.isActive = true;
          this.$store.state.layer_index = i;
          this.$store.state.selectedLayer = this.$store.state.layers[this.$store.state.layer_index];
          this.$store.state.img = "https://raw.githubusercontent.com/yovavsanders/govmap/master/images/"+this.selectedLayer.layer_name+".jpg";
          this.$store.state.turnOnLayers.push(this.selectedLayer.layer_name)
          govmap.setVisibleLayers(this.$store.state.turnOnLayers, this.$store.state.turnOffLayers)

          this.$store.state.clickMapMessage = true;

        } else {
          this.isActive = false;
          this.$store.state.layer_index = -1;
          this.$store.state.selectedLayer = null;
          //consle.log()
          govmap.unbindEvent(govmap.events.CLICK);
          govmap.refreshResource({ resource: 'sites' });
          govmap.setVisibleLayers([], this.allLayers)
        }
      }
      else{
          this.isActive = false;
          this.$store.state.layer_index = i;
          this.$store.state.selectedLayer = this.$store.state.layers[this.$store.state.layer_index];
          this.$store.state.img = "https://raw.githubusercontent.com/yovavsanders/govmap/master/images/"+this.selectedLayer.layer_name+".jpg";
          ////////console.log(this.$store.state.img)
          ////////console.log(this.$store.state.img);
          govmap.setVisibleLayers([this.selectedLayer.layer_name], this.unselectedLayers)

          console.log("govmap.onEvent(govmap.events.CLICK)");
                           govmap.onEvent(govmap.events.CLICK).progress(function(e){
                    //////console.log(thisVue.selectedLayer.fields)
                    thisVue.closeArrow = true;
                    var wkt = PointToPolygon(e.mapPoint.x, e.mapPoint.y, 1)
                    var layersToQuery = [thisVue.layers[0], thisVue.layers[1], thisVue.layers[2]]
                    for (var i = 0; i < layersToQuery.length; i++)
                    {
                      thisVue.getData(wkt, layersToQuery[i].layer_name, layersToQuery[i].fields);
                    }
                  }); 


          this.$store.state.clickMapMessage = true;

          this.isActive = true;

      }
      if(this.isMobile()){
        this.drawer = false;
      }
      else{
        this.getSelectedLayers();
      }
      this.getSelectedLayers();
    },

       getSelectedLayers(){

        this.$store.state.selectedlayers = [];

        var newarray = [];
        
        for (var a = 0; a < this.$store.state.groups.length; a++)
        {
            for (var b = 0; b < this.$store.state.groups[a].sub_groups.length; b++)
            {
                    ////console.log(this.$store.state.groups[a].sub_groups[b].selected);
                    this.$store.state.groups[a].sub_groups[b]
                    for (var i = 0; i < this.$store.state.groups[a].sub_groups[b].selected.length; i++)
                    {
                        ////console.log(this.$store.state.groups[a].sub_groups[b].selected[i]);
                        newarray.push(this.$store.state.groups[a].sub_groups[b].selected[i])
                    }
                
            }
        }

        for (var a = 0; a < this.$store.state.groups.length; a++)
        {
            for (var b = 0; b < this.$store.state.groups[a].sub_groups.length; b++)
            {
                  ////console.log(this.$store.state.groups[a].sub_groups[b].selected);
                  var layers = this.$store.state.groups[a].sub_groups[b].sub_group_layers;
                  //console.log(layers);
                  //console.log(newarray);
                  var res = layers.filter(item => newarray.includes(item.layer_name));
                  //console.log("res");
                  //console.log(res);
                  for (var i = 0; i < res.length; i++ )
                  {
                      //this.$store.state.selectedlayers.push(res[i]);
                                  
                        var symbols = this.createRenderer(res[i]);
                        ////console.log(symbols);
                        var obj = {
                          layer_name: res[i].layer_name,
                          text: res[i].text,
                          items: symbols
                        }
                        
                        this.$store.state.selectedlayers.push(obj);
                  }
            }
        }
        console.log(this.$store.state.selectedlayers);
        this.$store.state.turnOnLayers = newarray;
        this.$store.state.turnOffLayers = this.getUnselectedLayers()


        if (this.$store.state.selectedMinhaliLayer){
            var symbols = this.createRenderer(this.$store.state.selectedMinhaliLayer);
            console.log(symbols);
            var obj = {
              layer_name: this.$store.state.selectedMinhaliLayer.layer_name,
              text: this.$store.state.selectedMinhaliLayer.text,
              items: symbols,
              symbol_field: this.$store.state.selectedMinhaliLayer.symbol_field

            }

            this.$store.state.selectedlayers.push(obj);
        }
        if (this.$store.state.selectedLayer){
            var symbols = this.createRenderer(this.$store.state.selectedLayer);
            console.log(symbols);
            var obj = {
              layer_name: this.$store.state.selectedLayer.layer_name,
              text: this.$store.state.selectedLayer.text,
              items: symbols,
            }
            this.$store.state.selectedlayers.push(obj);
        }

        return newarray;
    },


    getUnselectedLayers () { 
        var newarray = [];
        for (var a = 0; a < this.$store.state.groups.length; a++)
        {
            for (var b = 0; b < this.$store.state.groups[a].sub_groups.length; b++)
            {
              for (var i = 0; i < this.$store.state.groups[a].sub_groups[b].sub_group_layers.length; i++)
              {
                //console.log(this.$store.state.groups[a].sub_groups[b].sub_group_layers.length);
                if (!this.$store.state.groups[a].sub_groups[b].selected.includes(this.$store.state.groups[a].sub_groups[b].sub_group_layers[i].layer_name)){
                    newarray.push(this.$store.state.groups[a].sub_groups[b].sub_group_layers[i].layer_name);
                }   
              }        
            }
         }
      //console.log(newarray);
      return newarray
    },

    checkSelectedLayers() { 
      var newarray = [];
      this.$store.state.selectedlayers = [];


         if (this.$store.state.selectedMinhaliLayer){
            var symbols = this.createRenderer(this.$store.state.selectedMinhaliLayer);
            ////console.log(symbols);
            var obj = {
              layer_name: this.$store.state.selectedMinhaliLayer.layer_name,
              text: this.$store.state.selectedMinhaliLayer.text,
              items: symbols,
              symbol_field: this.$store.state.selectedMinhaliLayer.symbol_field

            }

            this.$store.state.selectedlayers.push(obj);
        }
        if (this.selectedLayer){
            var symbols = this.createRenderer(this.selectedLayer);
            ////console.log(symbols);
            var obj = {
              layer_name: this.selectedLayer.layer_name,
              text: this.selectedLayer.text,
              items: symbols,
            }
            this.$store.state.selectedlayers.push(obj);
        }


      //groups[0].sub_groups[0].selected
      for (var a = 0; a < this.$store.state.groups.length; a++)
      {
          for (var b = 0; b < this.$store.state.groups[a].sub_groups.length; b++)
          {
                  ////console.log(this.$store.state.groups[a].sub_groups[b].selected);
                  this.$store.state.groups[a].sub_groups[b]
                  for (var i = 0; i < this.$store.state.groups[a].sub_groups[b].selected.length; i++)
                  {
                      ////console.log(this.$store.state.groups[a].sub_groups[b].selected[i]);
                      newarray.push(this.$store.state.groups[a].sub_groups[b].selected[i])
                      if (this.$store.state.groups[a].sub_groups[b].selected[i] == 'sites_tkufat_bniya_prod'){
                        govmap.zoomToXY({ x: 179300, y: 661800, level: 4, marker: false });
                      }
                  }
              
          }
      }

      for (var a = 0; a < this.$store.state.groups.length; a++)
      {
          for (var b = 0; b < this.$store.state.groups[a].sub_groups.length; b++)
          {
                ////console.log(this.$store.state.groups[a].sub_groups[b].selected);
                var layers = this.$store.state.groups[a].sub_groups[b].sub_group_layers;
                //console.log(layers);
                //console.log(newarray);
                var res = layers.filter(item => newarray.includes(item.layer_name));
                //console.log("res");
                //console.log(res);
                for (var i = 0; i < res.length; i++ )
                {
                    //this.$store.state.selectedlayers.push(res[i]);
                                 
                      var symbols = this.createRenderer(res[i]);
                      ////console.log(symbols);
                      var obj = {
                        layer_name: res[i].layer_name,
                        text: res[i].text,
                        items: symbols
                      }
                      
                      this.$store.state.selectedlayers.push(obj);
                }
          }
      }
      console.log(this.$store.state.selectedlayers);
      this.$store.state.turnOnLayers = newarray;
      this.$store.state.turnOffLayers = this.getUnselectedLayers()
      govmap.setVisibleLayers(this.$store.state.turnOnLayers, this.$store.state.turnOffLayers);
           
      //return newarray;
    },

  
    getData(wkt, lyr, fields){
      var thisVue = this;
      thisVue.drawer = false;
        var params = {  
            geometry: wkt, //point: {x: 167127.5939715321,  y: 624580.483296493},  // need wkt polygon...
            layerName: lyr,  
            fields: fields
        }
        govmap.intersectFeatures(params).then(function (response)  
        {  
            ////////console.log(response.data[0]);
            var name_eng;
            if (lyr == 'sites_pop_by_region'){
              thisVue.$store.state.selected_data_reg = response.data[0].Values;
              if (lyr == thisVue.selectedLayer.layer_name){
                name_eng = thisVue.$store.state.selected_data_reg[2];
                //thisVue.$store.state.img = "https://raw.githubusercontent.com/yovavsanders/govmap/master/images/sites_pop_by_region/" + name_eng + ".jpg";
              }

            }
            if (lyr == 'sites_arab_pop_by_religion'){
              thisVue.$store.state.selected_data_arab = response.data[0].Values;
              if (lyr == thisVue.selectedLayer.layer_name){
                  name_eng = thisVue.$store.state.selected_data_arab[1];
                  //thisVue.$store.state.img = "https://raw.githubusercontent.com/yovavsanders/govmap/master/images/sites_arab_pop_by_religion/" + name_eng + ".jpg";
              }

            }
            if (lyr == 'sites_pop_by_natural_areas'){
              thisVue.$store.state.selected_data_natural = response.data[0].Values;
              if (lyr == thisVue.selectedLayer.layer_name){
                name_eng = thisVue.$store.state.selected_data_natural[2];
              }
              
            }
            if (lyr == thisVue.selectedLayer.layer_name){
            thisVue.$store.state.img = "https://raw.githubusercontent.com/yovavsanders/govmap/master/images/"+thisVue.selectedLayer.layer_name+"/" + name_eng + ".jpg";
            govmap.searchInLayer({ 'layerName': thisVue.$store.state.layers[thisVue.$store.state.layer_index].layer_name, 'fieldName': 'OBJECTID',
                              'fieldValues': [response.data[0].ObjectId],
                              'highlight': true,
                              'showBubble':false,
                              'outLineColor':[127, 246, 223, 1],
                              'outlineWidth': 1, 
                              'fillColor': [255, 255, 255, 0.5]});
            }
            
            //if (thisVue.isMobile())
            //{
               thisVue.$vuetify.goTo("#DataCard");
               thisVue.showArrow = true;
            //}
        });

    },
  },

     computed:{


    legendCol(){
     if (this.anyLayers){
        
        return 6
       }   
      else{
        return 8
      }
    },

    layersCol(){
     if (this.anyLayers){
        
        return 3
       }   
      else{
        return 4
      }
    },


    selectedlayers(){
      return this.$store.state.selectedlayers
    },
    showLayerInfo(){
     return this.$store.state.showLayerInfo
    },
    LayerNameInfo(){
      return this.$store.state.LayerNameInfo;
    },





   
    
    
   
     layers(){
       return this.$store.state.layers;
     },
     minhali(){
        return this.$store.state.minhali;
     },
     minhali_index(){
       return this.$store.state.minhali_index;
     },
     layer_index(){
       return this.$store.state.layer_index;
     },
     selectedLayer () {
      return this.$store.state.selectedLayer;
    },
    selectedMinhaliLayer(){
      return this.$store.state.selectedMinhaliLayer;
    },
    unselectedLayers () { 
      var newarray = [];
      for (var i = 0; i < this.$store.state.layers.length; i++)
      {
        if (i != this.$store.state.layer_index){
          newarray.push(this.$store.state.layers[i].layer_name)
        }
      }
      ////////console.log(newarray);
      return newarray
    },
    unselectedMinhaliLayers () { 
      var newarray = [];
      for (var i = 0; i < this.$store.state.minhali.length; i++)
      {
        if (i != this.$store.state.minhali_index){
          newarray.push(this.$store.state.minhali[i].layer_name)
        }
      }
      ////////console.log(newarray);
      return newarray
    },

     allLayers () { 
      var newarray = [];
      for (var i = 0; i < this.$store.state.layers.length; i++)
      {
          newarray.push(this.$store.state.layers[i].layer_name)
        
      }
      ////////console.log(newarray);
      return newarray
    },
  
    allMinhaliLayers () { 
      var newarray = [];
      for (var i = 0; i < this.$store.state.minhali.length; i++)
      {
          newarray.push(this.$store.state.minhali[i].layer_name)
        
      }
      ////////console.log(newarray);
      return newarray
    },
    selected_data_reg(){
      return this.$store.state.selected_data_reg;
    },
    selected_data_arab(){
      return this.$store.state.selected_data_arab;
    }
  },


  }



</script>

<style>
::v-deep .my-checkbox .v-label {
 font-size: 10px;
}
</style>